import type { TimeRange} from "@@/shared/date-time/time-range";
import { timeRangeZodSchema } from "@@/shared/date-time/time-range";

import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { OrderId} from "@@/shared/orders/order-id";
import { orderIdZodSchema } from "@@/shared/orders/order-id";
import type {
    ProviderId} from "@@/shared/providers/provider-id";
import {
    providerIdZodSchema,
} from "@@/shared/providers/provider-id";
import { genericId } from "@@/utilities/generic-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    BookableSessionId} from "../../sessions/bookable-session-id";
import {
    bookableSessionIdZodSchema,
} from "../../sessions/bookable-session-id";

type ChangeReservationTimeForOrderCommand = {
    _id: string;
    _createdAt: IsoAndUnixTimestamp;
    _type: "CHANGE_RESERVATIONS_TIME_FOR_ORDER_COMMAND";
    providerId: ProviderId;

    orderId: OrderId;
    timeRange: TimeRange;
    session?: BookableSessionId;
};

type FactoryParams = Except<
    ChangeReservationTimeForOrderCommand,
    "_id" | "_type" | "_createdAt"
>;
const { factory: generateId, zodSchema: resourceChangeReservationIdZodSchema } =
    genericId("change_reservation_for_order__", {
        regexMatch: /(^change_reservation_for_order_.*$)/,
    });

const changeReservationTimeForOrderFactory = (params: FactoryParams) => {
    const command: ChangeReservationTimeForOrderCommand = {
        ...params,
        _id: generateId(),
        _type: "CHANGE_RESERVATIONS_TIME_FOR_ORDER_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

const changeReservationTimeForOrderCommandSchema: z.ZodSchema<ChangeReservationTimeForOrderCommand> =
    z.object({
        _id: resourceChangeReservationIdZodSchema,
        _type: z.literal("CHANGE_RESERVATIONS_TIME_FOR_ORDER_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        providerId: providerIdZodSchema,
        orderId: orderIdZodSchema,
        timeRange: timeRangeZodSchema,
        session: bookableSessionIdZodSchema.optional(),
    });

export {
    changeReservationTimeForOrderCommandSchema,
    changeReservationTimeForOrderFactory,
};
export type { ChangeReservationTimeForOrderCommand };
